import { render } from "./v-tariff-item.vue?vue&type=template&id=065bdcf3"
import script from "./v-tariff-item.vue?vue&type=script&lang=js"
export * from "./v-tariff-item.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dev\\Desktop\\relocation\\Aktikom\\Aktikom_projects\\rucred-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__